import { TemplateField } from './../activities/print-template-activity';
import { Observable } from 'rxjs';
import { DataEntity } from './data-entity';
import { fabric } from 'fabric';
import { PointGroup } from 'signature_pad';

export class SketchDataEntity extends DataEntity {
  image?: string;
  data: Array<PointGroup>;

  constructor(options?: Partial<SketchDataEntity>) {
    super(options);

    this.dataEntityTypeCode = 'sketch';
    this.dataEntityTypeDescription =
      'Use this entity type to represent a Sketch.';
    this.dataEntityTypeName = 'Sketch';
    this.hasEditor = false;

    if (options) {
      Object.assign(this, options);
    }
  }

  private setScale(fieldInfo, image, helperFunctions) {
    const placeHolderWidth = fieldInfo.width
      ? helperFunctions.documentToScreenX(fieldInfo.width)
      : helperFunctions.documentToScreenX(392);
    const placeHolderHeight = fieldInfo.height
      ? helperFunctions.documentToScreenY(fieldInfo.height)
      : helperFunctions.documentToScreenY(392);

    image.scaleX = placeHolderWidth / image.width;
    image.scaleY = placeHolderHeight / image.height;
  }

  async formatTemplateItem(fieldInfo, helperFunctions): Promise<fabric.Object> {
    return new Promise((resolve, reject) => {
      fabric.Image.fromURL(
        '/assets/images/pdf-sketch-placeholder_pink.jpg',
        img => {
          this.setScale(fieldInfo, img, helperFunctions);

          img.left = helperFunctions.documentToScreenX(fieldInfo.x);
          img.top = helperFunctions.documentToScreenY(fieldInfo.y);
          img.hasBorders = true;
          img.padding = 1;
          img.borderColor = 'black';
          img.editable = false;
          img.backgroundColor = !this.isValid ? 'red' : 'rgba(0, 0, 0, .1)';

          return resolve(img);
        }
      );
    });
  }

  resizeTemplateItem(
    fieldInfo: TemplateField,
    helperFunctions,
    image: fabric.Object
  ): void {
    if (fieldInfo) {
      image.left = helperFunctions.documentToScreenX(fieldInfo.x);
      image.top = helperFunctions.documentToScreenY(fieldInfo.y);

      this.setScale(fieldInfo, image, helperFunctions);

      image.setCoords();
    }
  }
}
